import { defineComponent as _defineComponent } from 'vue'
import DomService from "@/core/dom.service";
import PageService from "@/core/page.service";
import QueryParamService, { QueryParams } from "@/core/query-params.service";
import ScrollService from "@/core/scroll.service";
import { store } from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'SpaServer',
  setup(__props) {

const metaData = computed<Metadata | undefined>(() => store.getters["app/metaData"]);
const isChangingPage = computed<boolean>(() => store.getters["app/isChangingPage"]);
const isInEditMode = computed<boolean>(() => store.getters["app/isInEditMode"]);
const hasModeChanged = computed<ModeChangeFunction>(() => store.getters["app/hasModeChanged"]);

function fetchPage(route: string) : Promise<PageDataViewModel> {
    return store.dispatch("app/fetchPage", route);
}

const progressBar = ref(null);

onMounted(() => {
    preventAutoScroll();
    uncloak();
    scrollTo();
});

function onRouteChange(route: RouteValues, oldRoute: RouteValues) {
    if (!route || !oldRoute || route.path === oldRoute.path) {
        return;
    }
    if (isInEditMode.value || hasModeChanged.value(route.path)) {
        return PageService.hardRedirect(route.fullPath);
    }

    fetchPage(route.fullPath).then(() => {
        // Push custom event to Google TagManager
        if ((window as any).dataLayer) {
            try {
                setTimeout(() => {
                    (window as any).dataLayer.push({
                        event: "spa-page-loaded"
                    });
                }, 500);
            } catch (exception) {}
        }
    });
}

const route = useRoute();
const routeValues = computed<RouteValues>(() => ({ path: route.path, query: route.query, fullPath: route.fullPath }));
watch(() => routeValues.value, onRouteChange, { deep: true, immediate: true });

function onMetadataChange(metaData: Metadata) {
    if (metaData) {
        DomService.updateMetaData(metaData);
    }
}
watch(metaData, onMetadataChange);

function onIsChangingPageChange(isChangingPage: boolean) {
    if (isChangingPage) {
        (progressBar.value as any).start();
    } else {
        (progressBar.value as any).done();
    }
}
watch(isChangingPage, onIsChangingPageChange);

function uncloak() {
    document.getElementById("lpapp").classList.remove("bootstrapping");
}

function preventAutoScroll() {
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }
}

function scrollTo() {
    const scrollToId = QueryParamService.getParam(QueryParams.ScrollToId);
    if (scrollToId) {
        const waitForDomToRender = 500;
        setTimeout(() => {
            const elementToScrollTo = document.getElementById(scrollToId);
            ScrollService.scrollToElement(elementToScrollTo, 0, 300);
        }, waitForDomToRender);
    }
}


return { __sfc: true,metaData, isChangingPage, isInEditMode, hasModeChanged, fetchPage, progressBar, onRouteChange, route, routeValues, onMetadataChange, onIsChangingPageChange, uncloak, preventAutoScroll, scrollTo }
}

})